<template>
    <!-- <header>
        <span class="btn" @click="goBack"><van-icon name="arrow-left" size="20" /></span>
        <span class="btn" @click="toShare()"><van-icon :name="require('@/assets/imgs/icon17.png')" size="20" /></span>
    </header> -->
    <div class="detail">
        <h5>{{ data.artName }}</h5>
        <div class="info">
            <div>{{ data.updateBy }}</div>
            <div class="icons">
                <img src="@/assets/imgs/icon5.png" alt=""> {{ data.browseCount }}
                <img src="@/assets/imgs/icon6.png" alt="" v-if="!isThumbsUp" @click="toggleThumbsUp">
                <img src="@/assets/imgs/icon18.png" alt="" v-else @click="toggleThumbsUp"> 
                {{ data.thumbsUpCount }}
            </div>
        </div>
        <div v-html="data.introduction" class="introduction"></div>
    </div>
    <ul v-if="data.modelAssets" class="modelAssets">
        <li v-for="item in data.modelAssets" :key="item.id">
            <AssetsCard :item="item" />
        </li>
    </ul>
    <ShareDialog ref="shareDialog" />
    <van-floating-bubble @click="toShare()" :icon="require('@/assets/imgs/icon17.png')" style="background-color: #fff; box-shadow:0 0 10rem rgba(0, 0, 0, 0.15);" />
</template>
<script setup>
import { onMounted, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import * as api from '@/request/front'
import AssetsCard from '@/views/front/components/AssetsCard.vue'
import ShareDialog from '@/views/front/components/ShareDialog.vue'

const router = useRouter()
const route = useRoute()
const data = reactive({})
const isThumbsUp = ref(false)
onMounted(() => {
    isThumbsUp.value = localStorage.getItem('thumbsUp-' + route.query.id) == '1'
    api.getNewsDetail(route.query.id).then(res => {
        Object.assign(data, res.data.data)
    })
})

const toggleThumbsUp = () => {
    api.likeNews(route.query.id, Number(!isThumbsUp.value)).then(res => {
        data.thumbsUpCount += isThumbsUp.value ? -1 : 1
        isThumbsUp.value = !isThumbsUp.value
        if(isThumbsUp.value){
            localStorage.setItem('thumbsUp-' + route.query.id, 1)
        }else{
            localStorage.setItem('thumbsUp-' + route.query.id, 0)
        }
    })
}

const shareDialog = ref(null)
const toShare = () => {
    shareDialog.value.show(location.href, ' 文章 - ' + data.artName)
}
const goBack = () => {
    if (window.history.length > 1) {
        router.back()
    } else {
        router.replace('/')
    }
}
</script>
<style scoped lang="scss">
header {
    display: flex;
    align-items: center;
    height: 60rem;
    justify-content: space-between;
    padding: 0 20rem;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

.detail {
    padding: 20rem;

    .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 30rem;
        .icons {
            display: flex;
            align-items: center;
            img {
                margin: 0 10rem;
                width: 15rem;
                height: auto;
            }
        }
    }
    .introduction{
        width: 100%; overflow-x: hidden; margin-top: 10rem;
        ::v-deep(img){
            max-width: 100% !important;
        }

    }
}
.modelAssets{
    padding: 15rem; display: flex; justify-content: space-between;
    li{
        width: 190rem;
    }
}
</style>